/* Jardim Brasil — animação da troca de quadro da tirinha.
   Camada aditiva: lê o movimento da tira (background-position-x) e devolve
   desfoque de movimento, varredura de luz, pólen com profundidade,
   assentamento no fim do percurso e entrada em cascata da legenda. */
(function () {
  'use strict';

  var REDUZ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  var seq = 0;

  function filtroSvg(id) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    var f = document.createElementNS(NS, 'filter');
    f.setAttribute('id', id);
    f.setAttribute('x', '-6%');
    f.setAttribute('y', '-6%');
    f.setAttribute('width', '112%');
    f.setAttribute('height', '112%');
    var b = document.createElementNS(NS, 'feGaussianBlur');
    b.setAttribute('stdDeviation', '0 0');
    b.setAttribute('edgeMode', 'duplicate');
    f.appendChild(b);
    svg.appendChild(f);
    document.body.appendChild(svg);
    return b;
  }

  function posX(el) {
    var v = getComputedStyle(el).backgroundPositionX;
    if (!v) return 0;
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function iniciar(secao) {
    var palco = secao.querySelector('.jbt__palco');
    var trilho = secao.querySelector('.jbt__trilho');
    if (!palco || !trilho || trilho.__jbtAnim) return;
    trilho.__jbtAnim = true;

    var cs = getComputedStyle(trilho);
    var podeFiltrar = cs.filter === 'none';
    var podeEscalar = cs.transform === 'none';
    if (podeEscalar) secao.classList.add('jbt-anim-pode-escalar');

    var sweep = document.createElement('i');
    sweep.className = 'jbt-anim__sweep';
    var poeira = document.createElement('i');
    poeira.className = 'jbt-anim__poeira';
    palco.appendChild(poeira);
    palco.appendChild(sweep);

    var particulas = [];
    if (!REDUZ) {
      var n = Math.max(10, Math.min(26, Math.round(palco.offsetWidth / 78)));
      for (var i = 0; i < n; i++) {
        var p = document.createElement('i');
        p.className = 'jbt-anim__p';
        var d = 4 + Math.random() * 9;
        p.style.width = d.toFixed(1) + 'px';
        p.style.height = d.toFixed(1) + 'px';
        p.style.opacity = (0.18 + Math.random() * 0.4).toFixed(2);
        poeira.appendChild(p);
        particulas.push({
          el: p,
          x: Math.random() * 100,
          y: Math.random() * 100,
          prof: 0.55 + Math.random() * 1.5,
          vy: -0.006 - Math.random() * 0.02,
          fase: Math.random() * 6.28,
          amp: 0.25 + Math.random() * 0.8
        });
      }
    }

    var desfoque = (!REDUZ && podeFiltrar) ? filtroSvg('jbtMotion' + (++seq)) : null;
    if (desfoque) trilho.style.filter = 'url(#' + desfoque.parentNode.getAttribute('id') + ')';

    var xAnt = posX(trilho);
    var velSuave = 0, tick = 0, viva = true, andando = false, temporizador = 0;

    function passo() {
      if (!viva) return;
      requestAnimationFrame(passo);
      tick++;

      var x = posX(trilho);
      var vel = x - xAnt;
      xAnt = x;
      velSuave += (vel - velSuave) * 0.28;

      var v = Math.abs(velSuave);
      var vNorm = Math.min(1, v / 42);

      if (desfoque) {
        var sd = Math.min(11, v * 0.20);
        desfoque.setAttribute('stdDeviation', (sd < 0.12 ? 0 : sd).toFixed(2) + ' 0');
      }

      if (!REDUZ) {
        sweep.style.opacity = (vNorm * 0.5).toFixed(3);
        sweep.style.transform = 'translate3d(' + (-velSuave * 2.2).toFixed(1) + 'px,0,0)';
      }

      for (var i = 0; i < particulas.length; i++) {
        var q = particulas[i];
        q.x -= (velSuave * q.prof) / palco.offsetWidth * 100 * 0.9;
        q.y += q.vy;
        if (q.x < -6) q.x += 112;
        if (q.x > 106) q.x -= 112;
        if (q.y < -6) q.y = 106;
        var ondula = Math.sin(tick * 0.012 + q.fase) * q.amp;
        q.el.style.left = (q.x + ondula).toFixed(2) + '%';
        q.el.style.top = q.y.toFixed(2) + '%';
        q.el.style.transform = 'translate3d(-50%,-50%,0)';
      }

      if (v > 2.2) {
        andando = true;
      } else if (andando && v < 0.3) {
        andando = false;
        secao.classList.remove('jbt-anim-assenta');
        void secao.offsetWidth;
        secao.classList.add('jbt-anim-assenta');
        clearTimeout(temporizador);
        temporizador = setTimeout(function () {
          secao.classList.remove('jbt-anim-assenta');
        }, 700);
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.isIntersecting && !viva) { viva = true; xAnt = posX(trilho); requestAnimationFrame(passo); }
          else if (!e.isIntersecting) { viva = false; }
        });
      }, { rootMargin: '160px' }).observe(secao);
    }
    requestAnimationFrame(passo);

    var legenda = secao.querySelector('.jbt__legenda');
    if (legenda && 'MutationObserver' in window) {
      var t2 = 0;
      new MutationObserver(function () {
        secao.classList.remove('jbt-anim-troca');
        void secao.offsetWidth;
        secao.classList.add('jbt-anim-troca');
        clearTimeout(t2);
        t2 = setTimeout(function () {
          secao.classList.remove('jbt-anim-troca');
        }, 780);
      }).observe(legenda, { childList: true, subtree: true, characterData: true });
    }
  }

  function varrer() {
    document.querySelectorAll('.jbt-secao').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else {
    varrer();
  }
  document.addEventListener('shopify:section:load', varrer);
})();
